<template>
<div id="printQuickOp">
    <CompanyInfo></CompanyInfo>
    <div style="border-top:1px solid #ddd;margin-top:5%;">
        <p style="position: absolute;left :30px; top:125px;"><b>Doctor Name&nbsp;&nbsp;&nbsp;:&nbsp;</b>
        {{this.$store.state.savedOpData.doctorName}}
        </p>
        <p style="position: absolute;left :30px; top:150px;"><b>Reg No&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
       {{this.$store.state.savedOpData.opId}}
        </p><br>
        <p style="position: absolute;left :450px; top:125px;"><b>Patient Name&nbsp;&nbsp;:&nbsp;</b>
        {{this.$store.state.savedOpData.patientName}}
        </p>
        <br>
        <p style="position: absolute;left :450px; top:150px;"><b>Age&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
        {{this.$store.state.savedOpData.age}}
        </p>
        <br>
        <p style="position: absolute;left :450px; top:175px;"><b>Sex&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
       {{this.$store.state.savedOpData.gender}}
        </p>
        <div v-if="this.$store.state.savedOpData.tokenNo">
            <br>
            <p style="position: absolute;left :30px; top:175px;"><b>Token No&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>{{this.$store.state.savedOpData.tokenNo}}</p>
            <br>
            <!-- <p style="position: absolute;left :30px; top:200px;"><b>Appoinment Date & Time&nbsp;&nbsp;:&nbsp;</b>{{this.$store.state.savedOpData.opDate}}&nbsp;-&nbsp;{{this.$store.state.savedOpData.appointmentTime}}</p> -->
        <p style="position: absolute;left :30px; top:200px;"><b>Appoinment Date & Time&nbsp;&nbsp;:&nbsp;</b>{{this.$store.state.savedOpData.appointmentTime}}</p>
        </div>
        <div style="border-bottom:1px solid #ddd;margin-top:20%;"></div>

    </div>
    <p style="position: absolute;left :450px; top:200px;"><b>Date&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:&nbsp;</b>
  {{this.$store.state.savedOpData.opDate}}
    </p>
    <div style="border-bottom:1px solid #ddd;margin-top:50px;height:60%;"></div>
    <div class="w3-col-m12 w3-border-top w3-center" style="margin-top:8px;"></div>
    <p style="margin-left:475px;">For&nbsp;{{this.$session.get('companyName')}}</p>
    <p style="margin-left:475px;">Printed at &nbsp;:&nbsp;{{new Date().toJSON().slice(0,10).replace(/-/g,'/')}}</p>

</div>
</template>

<script>
import CompanyInfo from '../components/CompanyInfo.vue';
export default {
    components: {
        CompanyInfo
    },

    // props: {
    //     opPrintData: {
    //         type: [Object, Array]
    //     },
    // },

}
</script>
